
import Naitei2023 from './modules/Naitei2023'
import Naitei2023single from './modules/Naitei2023single'

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.naitei2023')) {
    const naitei2023 = new Naitei2023()
  }
  if (document.querySelector('.single-naitei2023')) {
    const naitei2023single = new Naitei2023single()
  }
})
